import { EditAppointmentType } from 'RestAPIs/activities/types';
import { createContext } from 'react';

export const PopOverConfirmationContext = createContext<{
  onClose: (() => void) | undefined;
  onHandleAppointmentConfirmation:
    | ((
        editAppointmentType: EditAppointmentType,
        isUnassignment?: boolean
      ) => void)
    | undefined;
  isLoading: boolean;
}>({
  onClose: undefined,
  onHandleAppointmentConfirmation: undefined,
  isLoading: false
});
